export default function MHAbout() {
  return (
    <section id="about" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-1 w-10 rounded-full" style={{ backgroundColor: "#CC1F1A" }} />
              <span className="text-sm font-bold uppercase tracking-widest text-gray-400">O projekcie</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight uppercase mb-6">
              Twój most<br />
              <span style={{ color: "#CC1F1A" }}>między krajami</span>
            </h2>
            <p className="text-gray-500 leading-relaxed mb-5">
              Meet Hiszpania powstała z myślą o polskich touroperatorach, agencjach turystycznych
              i profesjonalistach branżowych, którzy szukają wiarygodnych, sprawdzonych partnerów
              na rynku hiszpańskim.
            </p>
            <p className="text-gray-500 leading-relaxed mb-8">
              Oferujemy dostęp do ekskluzywnych obiektów, organizujemy wizyty studyjne
              i eventy networkingowe w Polsce, budując trwałe relacje biznesowe między obu krajami.
            </p>
            <div className="flex flex-wrap gap-3">
              {["Turystyka luksusowa", "Golf & Wellness", "MICE & Events", "Sport & Active", "Rodziny"].map(tag => (
                <span key={tag} className="px-4 py-1.5 bg-gray-100 text-gray-600 text-xs font-semibold rounded-full uppercase tracking-wide">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5">
            {[
              { value: "2", label: "Destynacje partnerskie", sub: "La Gomera & Fuerteventura" },
              { value: "100+", label: "Agencji w sieci", sub: "Polska" },
              { value: "3+", label: "Eventy B2B", sub: "rocznie w Polsce" },
              { value: "5+", label: "Lat doświadczenia", sub: "na rynku turystycznym" },
            ].map((item) => (
              <div
                key={item.label}
                className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-red-200 transition-colors"
              >
                <p className="text-5xl font-extrabold mb-1" style={{ color: "#CC1F1A" }}>
                  {item.value}
                </p>
                <p className="text-sm font-bold text-gray-800 uppercase tracking-wide leading-snug">
                  {item.label}
                </p>
                <p className="text-xs text-gray-400 mt-1">{item.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
